module.exports = __webpack_public_path__ + "img/16.7f57420c.png";